


















































































import Vue from "vue";
import _ from "lodash";
import { reBuildColumns } from "@/utils/table";
import { FilterTypes } from "@/scripts/enums";

export default Vue.extend({
    name: "DetailPlanCard",
    props: {
        planItem: {
            type: Object,
            required: true
        },
        orgConfig: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            rowWidth: ["80%", "90%", "90%", "80%"],
            titleWidth: "60%",
            isExpandDetail: false
        };
    },
    methods: {
        switchPlanDetail(val: boolean) {
            this.isExpandDetail = val;
        }
    },
    computed: {
        loading(): boolean {
            return _.isEmpty(this.planItem);
        },
        trainingOccupationEnabled(): boolean {
            if (_.keys(this.orgConfig).length == 0) {
                return true;
            }
            return !!this.orgConfig["trainingOccupationEnabled"];
        },
        copyPlanEnabled(): boolean {
            if (_.keys(this.orgConfig).length == 0) {
                return false;
            }
            return !!this.orgConfig["copyPlanEnabled"];
        },
        subDetailList(): any[] {
            const result: any[] = reBuildColumns(
                [
                    {
                        title: this.$t("common.planVersion"),
                        content: this.$t("common.planVersionValue", [1])
                    },
                    {
                        type: FilterTypes.CLASSIFICATIONS,
                        title: this.$t("common.classification"),
                        content: this.planItem.classificationName
                    },
                    {
                        type: FilterTypes.OCCUPATIONS,
                        title: this.$t("common.occupation"),
                        content: this.planItem.occupationName
                    },
                    {
                        type: FilterTypes.LEVELS,
                        title: this.$t("common.level"),
                        content: this.planItem.levelName
                    },
                    {
                        title: this.$t("common.trainingType"),
                        content: this.planItem.trainingType
                    },
                    {
                        title: this.$t("plan.expectedOpeningTime"),
                        content: this.planItem.expectedOpeningTime
                    },
                    {
                        title: this.$t("common.registrationEnrollmentCount"),
                        content: this.planItem.registrationEnrollmentCount
                    }
                ],
                [
                    { name: FilterTypes.CLASSIFICATIONS, isShow: this.trainingOccupationEnabled },
                    { name: FilterTypes.OCCUPATIONS, isShow: this.trainingOccupationEnabled },
                    { name: FilterTypes.LEVELS, isShow: this.trainingOccupationEnabled }
                ]
            );
            return this.isExpandDetail ? result : result.slice(0, 2);
        }
    }
});
